import {
  Div,
  GetPublishSyncStatusResponse,
  Icon,
  Img,
  lightTheme,
  P,
  Pill,
  Provider,
  publishMenuForSpecifiedProvider,
  renderProviderIcon,
  renderProviderName,
  RetryIcon,
  SyncStatus,
  TooltipIcon,
  TooltipWrapper,
  reportError,
} from '@vgrubs/components';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  renderMenuSyncStatusColor,
  renderMenuSyncStatusName,
} from '../helpers';

export const ProviderStatusSyncList = ({
  syncStatus,
  setSyncStatus,
  locationId,
  brandId,
}: {
  syncStatus: GetPublishSyncStatusResponse | null;
  setSyncStatus: (syncStatus: GetPublishSyncStatusResponse | null) => void;
  locationId: string;
  brandId: string;
}) => {
  const navigate = useNavigate();
  const [loadingRetryProvider, setLoadingRetryProvider] = useState<Provider[]>(
    []
  );

  const isLoadingRetryProvider = (provider: Provider) =>
    loadingRetryProvider.includes(provider);

  const stopLoadingRetryProvider = (provider: Provider) => {
    setLoadingRetryProvider((prev) => prev.filter((p) => p !== provider));
  };

  const handleRetryFailedProvider = async (provider: Provider) => {
    setLoadingRetryProvider((prev) => [...prev, provider]);
    try {
      const { data } = await publishMenuForSpecifiedProvider(
        locationId,
        brandId,
        provider
      );
      setSyncStatus(data.data);
    } catch (error) {
      reportError(error);
    } finally {
      stopLoadingRetryProvider(provider);
    }
  };
  return (
    <Div $flex $alignCenter $gap="8px" $gapSM="8px" $wrap $mb="16">
      {syncStatus?.syncList
        .sort((a, b) => a.provider.localeCompare(b.provider))
        .map(({ provider, status, errorMessage }) => (
          <Pill
            $background={lightTheme.white}
            $padding={`0px ${
              status !== SyncStatus.Failed ? '12px' : '0px'
            } 0px 0px`}
            $shadow
            $pointer={status === SyncStatus.Waiting}
            onClick={() => {
              if (status === SyncStatus.Waiting) {
                navigate(
                  brandId !== '0'
                    ? `/brands/manage-providers/${brandId}/${locationId}`
                    : `/locations/manage-providers/${locationId}`
                );
              }
            }}
          >
            <Div $flex $alignCenter $gap="6px">
              <Img alt="" src={renderProviderIcon(provider)} $width="24px" />
              <P $m="0" style={{ flex: 'none' }}>
                {renderProviderName(provider)}:{' '}
                <span
                  style={{
                    color: renderMenuSyncStatusColor(status),
                  }}
                >
                  {renderMenuSyncStatusName(status)}
                </span>
              </P>
              {status === SyncStatus.Failed && (
                <>
                  {errorMessage && (
                    <TooltipIcon
                      tooltip={errorMessage}
                      color={lightTheme.primary}
                    />
                  )}

                  <TooltipWrapper tooltip="Retry">
                    <Div
                      $pointer
                      $color={lightTheme.primary}
                      onClick={() => handleRetryFailedProvider(provider)}
                    >
                      <Icon
                        $size={16}
                        color={lightTheme.white}
                        $m="0"
                        $verticalAlignBottom
                        $background={lightTheme.primary}
                        $backgroundSize={24}
                        $rotateAnimation={isLoadingRetryProvider(provider)}
                      >
                        <RetryIcon />
                      </Icon>
                    </Div>
                  </TooltipWrapper>
                </>
              )}
            </Div>
          </Pill>
        ))}
    </Div>
  );
};
